import React from 'react';
import styles from './BackGround.module.scss';

const BackGround = () => {
    return (
        <div className={styles.bg}>
            {/* <div className={styles.top_park}>
                <img className={styles.beijing_img} src={require('@/assets/image/login-bg.png').default} />
                <img className={styles.beijing_txt} src={require('@/assets/image/bgtxt.png').default} />
            </div> */}
            <div className={styles.bottom_park}>
                <div className={styles.companyname}>普惠空间（重庆）数字科技有限公司</div>
            </div>
        </div>
    );
};

export default BackGround;